import React, { useState, useEffect, useContext } from 'react';
import styles from '../components/pmn/index.module.scss';
import { ScreensContext } from '../contexts/screensContext';
import MenuScreen from '../common/menu-screen';
import ErrorScreen from '../components/lm-d-s/errorScreen';
import CharacteristicScreen from '../components/lm-d-s/characteristic-screen';
import InfoScreen from '../components/lm-d-s/info-screen';
import AuthorityScreen from '../common/authority-screen';
import WelcomeChallengeScreen from '../common/challenge-component/welcome-challenge-screen';
import ResultInfoScreen from '../common/challenge-component/result-info-screen';
import FinalScreen from '../components/lm-d-s/final-screen';
import DailyTasksChallenge from '../common/challenge-component/daily-tasks-challenge';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import AllBrandsScreen from '../common/all-brands-screen';
import BrandLineScreen from '../common/brand-line-screen';
import PredictionScreen from '../common/prediction-screen';
import { getImageFromS3 } from '../imageService';
import ReviewFlowScreen from '../common/review-flow-screen';
import { CURRENT_CHALLENGE_NAME } from '../consts/challengeName';
import useScreenHistory from '../hooks/useScreenHistory';

const dailyTasksChallengeList = {
  1: (
    <>Життя - це не те, що відбувається з тобою, а те, як ти реагуєш на це 😎</>
  ),
  2: (
    <>
      Ти маєш вибір: бути оптимістом чи песимістом. Обирай оптимізм — він веде
      до світлого майбутнього 💡
    </>
  ),
  3: <>Успіх – це сума маленьких зусиль, повторюваних щодня 🎯</>,
  4: <>Не бійся змін — вони можуть виявитися кращим, ніж ти очікував 🤫</>,
  5: <>Сьогодні — єдиний день, який маємо. Використовуй його максимально ⏳</>,
  6: (
    <>
      Ти не можеш вплинути на те, що сталося вчора, але ти можеш визначити своє
      завтра 🌠
    </>
  ),
  7: <>Віра в себе — це перший секрет успіху ⚡</>,
  8: <>Мрій, якщо хочеш, але не забувай прокидатися і діяти 🚀</>,
  9: <>Не обговорюй свої плани — реалізовуй їх 🚀</>,
  10: <>Щоб досягти успіху, ти маєш пройти туди, куди інші бояться 🔥</>,
  11: <>Твій час обмежений, не витрачай його, живучи чужим життям ⏳</>,
  12: (
    <>
      Зроби своє сьогодення таким чудовим, щоб його було приємно згадувати
      завтра 🎞
    </>
  ),
  13: (
    <>Завжди можна знайти щось позитивне, навіть у найскладніших ситуаціях 🧐</>
  ),
  14: <>Ти маєш в собі неймовірну силу — знайди її та використай 😎</>,
  15: <>Найбільший успіх — це перемога над собою 🏆</>,
  16: <>Не бійся ризикувати — це може відкрити нові можливості 📌</>,
  17: <>Будь завзятим у тому, що ти робиш, і вір у свою силу 😎</>,
  18: <>Життя — це не те, що тобі випадає, а те, що ти робиш 🎨</>,
  19: <>Навчайся на помилках і рухайся вперед ⚡</>,
  20: (
    <>Не чекай на ідеальний момент — він ніколи не прийде. Починай зараз ✨</>
  ),
  21: (
    <>
      Ти не можеш змінити напрямок вітру, але завжди можеш налаштувати вітрила
      🤫
    </>
  ),
  22: (
    <>
      Справжня сила полягає в тому, щоб не здаватися, коли здається, що вже
      немає сил ⚡
    </>
  ),
  23: <>Підкреслюй свою унікальність — це те, що робить тебе особливим 🎨</>,
  24: <>Прагнення до успіху важливіше за сам успіх 🧐</>,
  25: <>Ти можеш зробити більше, ніж ти думаєш 😉</>,
  26: (
    <>Будь завзятий у своїх мріях, бо саме ти робиш своє життя неймовірним 😉</>
  ),
  27: <>Наважся мріяти масштабно і починай з того, що маєш 😎</>,
  28: <>Справжня свобода — це можливість бути самим собою 😉</>,
  29: <>Переможці не роблять виправдань, вони створюють можливості 😎</>,
  30: <>Не дивися назад, ти йдеш у майбутнє 🌠</>,
  31: <>Зміни світ, починаючи з себе ✨</>,
  32: (
    <>Ти визначаєш свій успіх — не дозволяй іншим визначати його за тебе 🙂</>
  ),
  33: (
    <>Усе починається з першого кроку. Якщо не рухаєшся, ніколи не дійдеш 🧐</>
  ),
  34: (
    <>
      Лише той, хто ризикує заради своїх мрій, може досягти великих успіхів 🏆
    </>
  ),
  35: (
    <>
      Твої можливості обмежуються лише тим, що ти готовий уявити. Мрій широко!
      ✨
    </>
  )
};

const menuList = [
  {
    id: 'challenge',
    screenNumber: 6,
    name: CURRENT_CHALLENGE_NAME,
    icon: 'images/common/menu-icon/may-challenge-menu-icon.svg'
  },
  {
    id: 'foresight',
    screenNumber: 12,
    name: 'Передбачення на сьогодні',
    icon: 'images/lm-double-splash/foresight-menu-icon.svg'
  },
  {
    id: 'characteristic',
    screenNumber: 2,
    name: 'Характеристики сигарет',
    icon: 'images/common/menu-icon/characteristic-menu-icon.svg'
  },
  {
    id: 'about',
    screenNumber: 3,
    name: 'Все про Філіп Морріс Україна',
    icon: 'images/common/menu-icon/info-menu-icon.svg'
  },
  {
    id: 'difference',
    screenNumber: 4,
    name: 'Як відрізнити підробку від оригіналу?',
    icon: 'images/common/menu-icon/authority-menu-icon.svg'
  },
  {
    id: 'review_main',
    screenNumber: 5,
    name: 'Залишити відгук про продукт',
    icon: 'images/common/menu-icon/review-menu-icon.svg'
  }
];

const partners = {
  cig: 'https://cig-poshta.in.ua/shop/lm/?utm_source=SP',
  rozetka: 'https://rozetka.com.ua/ua/sigareti/c4638591/producer=b84d5fce/'
};

const selectedPack = {
  title: 'Bond Street Premium Blue',
  pack: getImageFromS3('images/packs/bond/premium-blue.png'),
  tobaccoFirst: 'Вміст смол, мг - 6',
  tobaccoSecond: 'Вміст нікотину, мг - 0.5',
  filterIcon: getImageFromS3('images/bond/filter.png'),
  background: `url("${getImageFromS3('images/bond/background-new.png')}")`,
  characteristicInfoList: [
    {
      title: 'Формат ',
      description: '- King Size Slim (Кінг сайз слім)'
    },
    {
      title: 'Кількість сигарет у пачці ',
      description: '– 20'
    },
    {
      title: 'Кількість пачок у блоці ',
      description: '– 10'
    }
  ],
  filterCharacteristicList: [
    {
      description: (
        <span>
          <b>Класичний ацетатний фільтр</b> з високоякісної целюлози, який
          затримує тверді частинки сигаретного диму.
        </span>
      ),
      bordered: false
    }
  ]
};

export default function BNDP6() {
  const toReviewButton = sessionStorage.getItem('r_b') === 'true';
  const { screenNumber, setScreenNumber, historyState, updateHistoryState } =
    useScreenHistory({
      initialScreen: toReviewButton ? 5 : 1,
      initialState: { brandLine: '' }
    });
  const brandLine = historyState.brandLine || '';
  const [endSessionType, setEndSessionType] = useState('SESSION_END');
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);
  const { init, sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [screenNumber]);

  useEffect(() => {
    init('Bond street premium blue');
    sendEvent('age_verification_without');
  }, [init]);

  const getScreen = (number, cb) => {
    switch (number) {
      case -1: {
        return (
          <AllBrandsScreen
            setScreenNumber={cb}
            setBrandLine={(brand) => {
              setScreenNumber(11, false, { brandLine: brand });
            }}
            handleBackButton={() => setScreenNumber(2, true)}
            historyState={historyState}
            updateHistoryState={updateHistoryState}
          />
        );
      }
      case 1: {
        return (
          <MenuScreen
            setScreenNumber={cb}
            menuList={menuList}
            backgroundImage={`url("${getImageFromS3(
              'images/bond/background-new.png'
            )}")`}
          />
        );
      }
      case 2: {
        return (
          <CharacteristicScreen
            brandId="bond"
            isNewMixture={selectedPack?.isNewMixture}
            title={selectedPack?.title}
            setScreenNumber={setScreenNumber}
            filterCharacteristicList={selectedPack?.filterCharacteristicList}
            infoList={selectedPack?.characteristicInfoList}
            tobaccoFirst={selectedPack?.tobaccoFirst}
            tobaccoSecond={selectedPack?.tobaccoSecond}
            packImage={selectedPack?.pack}
            handleBackButton={() => setScreenNumber(1, true)}
            handleNextButton={() => setScreenNumber(9)}
            fullRangeButtonClick={() => setScreenNumber(-1)}
            backgroundImage={selectedPack?.background}
            filterIcon={selectedPack?.filterIcon}
            nextButtonTitle="Далі"
          />
        );
      }
      case 3: {
        return (
          <InfoScreen
            setScreenNumber={cb}
            setReviewScreenNumber={() => setScreenNumber(9)}
          />
        );
      }
      case 4: {
        return (
          <AuthorityScreen
            setScreenNumber={cb}
            setReviewScreenNumber={() => setScreenNumber(9)}
            partners={partners}
          />
        );
      }
      case 5: {
        return (
          <ReviewFlowScreen
            setScreenNumber={cb}
            setSubmitReviewScreenNumber={() => setScreenNumber(10)}
            innerScreenNumber={historyState.innerScreenNumber}
            setInnerScreenNumber={(val) =>
              setScreenNumber(5, false, { innerScreenNumber: val })
            }
          />
        );
      }
      case 6: {
        return (
          <WelcomeChallengeScreen
            setScreenNumber={cb}
            title={
              <>
                Натхнення
                <br />
                на день
              </>
            }
            description={`Трохи не вистачає мотивації? Ми підготували генератор натхнення, який точно налаштує тебе на правильний настрій.`}
            buttonTitle="Почати"
            backgroundImage={`url("${getImageFromS3(
              'images/bond/background-new.png'
            )}")`}
            setNextScreenNumber={() => setScreenNumber(7)}
          />
        );
      }
      case 7: {
        return (
          <DailyTasksChallenge
            title={
              <>
                Твоя порція натхнення
                <br />
                на сьогодні:
              </>
            }
            acceptChallengeCopy="Приймаю"
            setScreenNumber={setScreenNumber}
            backgroundImage={`url("${getImageFromS3(
              'images/bond/background-new.png'
            )}")`}
            dailyTasksList={dailyTasksChallengeList}
            dailyTasksListCount={Object.keys(dailyTasksChallengeList).length}
          />
        );
      }
      case 8: {
        return (
          <ResultInfoScreen
            setScreenNumber={setScreenNumber}
            setNextScreenNumber={() => setScreenNumber(9)}
            title="Відчуваєш позитивний заряд?"
            description={
              <>
                Заходь до нас завтра та отримай <br />
                нову порцію натхнення.
              </>
            }
            image={getImageFromS3('images/bond/man-c.png')}
            backgroundImage={`url("${getImageFromS3(
              'images/bond/background-new.png'
            )}")`}
          />
        );
      }
      case 9: {
        return (
          <FinalScreen
            setScreenNumber={cb}
            setScreenNumberToReview={() => setScreenNumber(5)}
            withReviewButton
            isUpdatedApp
          />
        );
      }
      case 10: {
        return <FinalScreen setScreenNumber={cb} />;
      }
      case 11: {
        return (
          <BrandLineScreen
            brandId={brandLine}
            setScreenNumber={setScreenNumber}
            backButtonClick={() => setScreenNumber(-1, true)}
            nextButtonClick={() => setScreenNumber(9)}
            historyState={historyState}
            updateHistoryState={updateHistoryState}
          />
        );
      }
      case 12: {
        return (
          <PredictionScreen
            setScreenNumber={setScreenNumber}
            handleBackButton={() => setScreenNumber(1, true)}
          />
        );
      }
      default: {
        return <ErrorScreen setScreenNumber={cb} />;
      }
    }
  };

  return (
    <div className={styles.pageContainer}>
      <div className={styles.contentContainer}>
        <ScreensContext.Provider
          value={{
            endSessionType,
            setEndSessionType,
            isDisplayedAll,
            setIsDisplayedAll
          }}
        >
          {getScreen(screenNumber, setScreenNumber)}
        </ScreensContext.Provider>
      </div>
    </div>
  );
}
